/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ControllerResponse_RentRollAttributes_ } from '../models/ControllerResponse_RentRollAttributes_';
import type { ControllerResponse_RentRollAttributes_Array_ } from '../models/ControllerResponse_RentRollAttributes_Array_';
import type { ControllerResponse_string_ } from '../models/ControllerResponse_string_';
import type { CreateRentRollAttributes } from '../models/CreateRentRollAttributes';
import type { LeaseData } from '../models/LeaseData';
import type { ParseRentRollResponse } from '../models/ParseRentRollResponse';
import type { Record_string_unknown_ } from '../models/Record_string_unknown_';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class RentrollService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @param type
     * @param formData
     * @returns ParseRentRollResponse Ok
     * @throws ApiError
     */
    public parseRentRoll(
        type: 'pdf' | 'excel' | 'csv',
        formData: {
            file: Blob;
        },
    ): CancelablePromise<ParseRentRollResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/rentroll/parse',
            query: {
                'type': type,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
        });
    }
    /**
     * Get the rent roll file from GCS.
     * @param rentRollId - The ID of the rent roll.
     * @returns ControllerResponse_string_ The file, as a base64 string.
     * @throws ApiError
     */
    public getRentRollFile(
        rentRollId: number,
    ): CancelablePromise<ControllerResponse_string_> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/rentroll/{rentRollId}/file',
            path: {
                'rentRollId': rentRollId,
            },
        });
    }
    /**
     * @param requestBody
     * @returns ControllerResponse_RentRollAttributes_ Ok
     * @throws ApiError
     */
    public saveRentRoll(
        requestBody: CreateRentRollAttributes,
    ): CancelablePromise<ControllerResponse_RentRollAttributes_> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/rentroll/save',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns ControllerResponse_RentRollAttributes_Array_ Ok
     * @throws ApiError
     */
    public listRentRolls(): CancelablePromise<ControllerResponse_RentRollAttributes_Array_> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/rentroll/list',
        });
    }
    /**
     * @param id
     * @param logVisit
     * @returns ControllerResponse_RentRollAttributes_ Ok
     * @throws ApiError
     */
    public getRentRollById(
        id: number,
        logVisit?: boolean,
    ): CancelablePromise<ControllerResponse_RentRollAttributes_> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/rentroll/{id}',
            path: {
                'id': id,
            },
            query: {
                'log_visit': logVisit,
            },
        });
    }
    /**
     * @param id
     * @param requestBody
     * @returns ControllerResponse_RentRollAttributes_ Ok
     * @throws ApiError
     */
    public updateRentRoll(
        id: number,
        requestBody: {
            reviewed?: boolean;
            metadata?: Record_string_unknown_ | null;
            as_of_date?: string | null;
            lease_data?: Array<LeaseData>;
            name?: string;
        },
    ): CancelablePromise<ControllerResponse_RentRollAttributes_> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/rentroll/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param id
     * @returns ControllerResponse_RentRollAttributes_ Ok
     * @throws ApiError
     */
    public deleteRentRoll(
        id: number,
    ): CancelablePromise<ControllerResponse_RentRollAttributes_> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/rentroll/{id}',
            path: {
                'id': id,
            },
        });
    }
}
